import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackPageView, initScrollTracking, cleanupScrollTracking } from './Utilities/Analytics';

class ScrollToTop extends Component {
    componentDidMount() {
      initScrollTracking();
    }

    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
        trackPageView(this.props.location.pathname);
        cleanupScrollTracking();
        initScrollTracking();
      }
    }

    componentWillUnmount() {
      cleanupScrollTracking();
    }
  
    render() {
      return this.props.children
    }
  }
  
  export default withRouter(ScrollToTop)